import * as React from 'react';
import classnames from 'classnames';

import { AppLink } from '@src/services/app/components/AppLink';
import { isExternalLink } from '@src/utils/link';

import styles from './styles.module.css';

export interface AppButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string;
  inverted?: number;
  layered?: number;
  thin?: number;
}

/**
 * @name AppButton
 * @description As we're extending the native element here, we are unable
 * to use a boolean attribute for those two props. Other than that, we still
 * have a very raw button to work with
 */
export const AppButton = (props: AppButtonProps) => {
  const {
    children,
    className,
    href,
    inverted = 0,
    layered = 0,
    thin = 0,
    type = 'button',
    ...rest
  } = props;

  // Setup
  const isExternal = isExternalLink(href);

  // Styles
  const cssComponent = classnames(styles.component, className, {
    // [styles.disabled]: props.disabled,
    [styles.layered]: layered === 1,
    [styles.secondary]: inverted === 1,
    [styles.thin]: thin === 1
  });

  if (isExternal) {
    return (
      <a className={cssComponent} href={href} style={props.style}>
        {children}
      </a>
    );
  }

  /**
   * Now we have our relative links (we have an href) which we're just
   * styling as a chunkier button
   */
  if (href) {
    return (
      <AppLink className={cssComponent} href={href} style={props.style}>
        {children}
      </AppLink>
    );
  }

  /**
   * And by default we're using a html button
   */
  return (
    // eslint-disable-next-line react/button-has-type
    <button {...rest} className={cssComponent} type={type}>
      {children}
    </button>
  );
};
